import { render, staticRenderFns } from "./AccountDeactivated.vue?vue&type=template&id=2b328ea6&scoped=true&"
import script from "./AccountDeactivated.vue?vue&type=script&lang=js&"
export * from "./AccountDeactivated.vue?vue&type=script&lang=js&"
import style0 from "./AccountDeactivated.vue?vue&type=style&index=0&id=2b328ea6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b328ea6",
  null
  
)

export default component.exports